/* tslint:disable */
/* eslint-disable */
/**
 * SEC AUDITOR API
 * Mehr unter https://sec-auditor.com
 *
 * The version of the OpenAPI document: 4.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetClientTeam200ResponseInner
 */
export interface GetClientTeam200ResponseInner {
    /**
     * Keycloak user UUID.
     */
    id?: string;
    /**
     * 
     */
    firstName?: string;
    /**
     * 
     */
    lastName?: string;
    /**
     * 
     */
    email?: string;
    /**
     * Pending Keycloak actions (e.g. email verification, password reset).
     */
    requiredActions?: Array<string>;
}

/**
 * Check if a given object implements the GetClientTeam200ResponseInner interface.
 */
export function instanceOfGetClientTeam200ResponseInner(value: object): value is GetClientTeam200ResponseInner {
    return true;
}

export function GetClientTeam200ResponseInnerFromJSON(json: any): GetClientTeam200ResponseInner {
    return GetClientTeam200ResponseInnerFromJSONTyped(json, false);
}

export function GetClientTeam200ResponseInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetClientTeam200ResponseInner {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'firstName': json['firstName'] == null ? undefined : json['firstName'],
        'lastName': json['lastName'] == null ? undefined : json['lastName'],
        'email': json['email'] == null ? undefined : json['email'],
        'requiredActions': json['requiredActions'] == null ? undefined : json['requiredActions'],
    };
}

export function GetClientTeam200ResponseInnerToJSON(json: any): GetClientTeam200ResponseInner {
    return GetClientTeam200ResponseInnerToJSONTyped(json, false);
}

export function GetClientTeam200ResponseInnerToJSONTyped(value?: GetClientTeam200ResponseInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'email': value['email'],
        'requiredActions': value['requiredActions'],
    };
}

